<!-- Root-Outlet: Routing übernimmt die gesamte Darstellung.
     MainLayoutComponent (mit Navbar + Sidebar) wird für alle geschützten Routen verwendet.
     LoginComponent wird für /login ohne Layout gerendert. -->
<router-outlet />
